
import { Vue, Component } from 'vue-property-decorator'
import SimpleTable from '@/components/busi/table/simple-table.vue'
import { getSchoolRoll } from '@/api/ordercenter'
import util from '@/utils/busi/util'

@Component({
  name: 'detailview',
  components: {
    SimpleTable
  }
})

export default class DetailView extends Vue {
  private params = util.getRouterParams()

  private tableData = {
    list: [],
    totalCount: 0
  }

  private pagination = null

  private loading = !1

  private columns = [
    {
      prop: 'stuBusinessName',
      label: '业务'
    },
    {
      prop: 'studyName',
      label: '学习类型'
    },
    {
      prop: 'stuSchoolName',
      label: '院校名称'
    },
    {
      prop: 'stuGradeName',
      label: '年级'
    },
    {
      prop: 'stuSubjectName',
      label: '专业'
    },
    {
      prop: 'stuSchoolRollStatusName',
      label: '学籍状态'
    },
    {
      prop: 'stuStateName',
      label: '状态'
    }
  ]

  beforeMount () {
    this.initData()
  }

  private async initData () {
    await getSchoolRoll({
      signupId: this.params.id
    }).then(async (res: any) => {
      if (res.code === 10000) {
        this.tableData.list = [res.object as never]
      }
    })
  }
}
